import { render, staticRenderFns } from "./PageMetaDataInput.vue?vue&type=template&id=16cb5136&scoped=true&"
import script from "./PageMetaDataInput.vue?vue&type=script&lang=ts&"
export * from "./PageMetaDataInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb5136",
  null
  
)

export default component.exports